import React from 'react'

import { WelcomeComponent } from 'components/Auth'

export const WelcomeContainer = () => {
  return (
    <WelcomeComponent />
  )
}
